import React from 'react';
import { useParams } from 'react-router-dom';
import Nav from '../components/nav/Nav';
import CategoryDetail from '../components/category-detail/CategoryDetail';
import Footer from '../components/footer/Footer';

function CategoryPage() {
  const { category_slug } = useParams();  //  Access category_slug

  return (
    <div className='page-container'>
      <Nav />
      <div className='page-content'>
        <CategoryDetail category_slug={category_slug} />
      </div>
      <Footer />
    </div>
  );
}

export default CategoryPage;
